export default {"src":"/_next/static/media/close.fee5d392.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};